import { render, staticRenderFns } from "./NavigationBig.vue?vue&type=template&id=47dc8773&"
import script from "./NavigationBig.vue?vue&type=script&lang=js&"
export * from "./NavigationBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports